import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export enum StatusColor {
  Green = 'green',
  Orange = 'orange',
  Red = 'red',
  Gray = 'gray'
}
@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnChanges {
  @Input() value?: string;
  @Input() color?: StatusColor;

  readonly defaultColor = StatusColor.Gray;
  colorToSet: StatusColor = this.defaultColor;
  
  predefinedColors: Record<string, StatusColor> = {
    'active': StatusColor.Green,
    'in active': StatusColor.Red,
  };
  
  ngOnChanges(changes: SimpleChanges) {
    if (this.value || !this.color) {
      const v = this.value?.toLowerCase()?.trim();
      if (!v?.length) {
        return;
      }
      const predefinedColor = this.predefinedColors[v];
      if (predefinedColor) {
        this.colorToSet = predefinedColor;
      }
    }
    if (this.value && this.color) {
      this.colorToSet = this.color;
    }
  }

}
